<div fxLayout="column" fxLayoutGap="15px">
  <div class="content-padding" fxLayout="row" fxLayoutAlign="start center">
    <div class="subtitle-default">Spaces</div>
    <button class="button-action" mat-flat-button fxFlexOffset="10px"
            (click)="addNewSpaceEvent()">
      <span class="button-text">Create a space</span>
    </button>
  </div>

  <div class="mat-elevation-z3 radius-10" fxLayout="column" fxFlexOffset="10px">
    <app-crud-table
      [title]="'Active spaces'"
      [loading$]="loader.loading$"
      [showLoaderBars]="false"
      [modelType]="CrudSpaces"
      [tableData]="spacesData"
      [updatedRow]="updatedRow"
      (rowSelected)="rowSelected($event)">
    </app-crud-table>
  </div>

  <mat-divider fxFlexOffset="30px"></mat-divider>
</div>
